class DynamicSuburbDialogController {
}

module.exports = {
    template: require('./dynamicsuburb-dialog.component.html').trim(),
    controller: [DynamicSuburbDialogController],
};



// WEBPACK FOOTER //
// ./src/shop/dynamicsuburb/dynamicsuburb-dialog.component.js